export const MAP_INSPECTOR_ACTION_TYPES = {
  SET_SELECTED_CROP:      'set-selected-crop',
  SET_HOVERED_CROP:       'set-hovered-crop',
  SET_PLOT_STATUS_MAP:    'set-plot-status-map',
  SET_RELATIONSHIP_COUNTS:'set-relationship-counts',
}

export const initialState = {
  selectedCropId:     null,
  selectedCropOrgId:  null,
  hoveredCropId:      null,
  plotStatusMap:      new Map(),  // Map<plotId, 'critical'|'warning'|'thriving'|'neutral'>
  relationshipCounts: { templateCompanion: 0, familyCompanion: 0, sameFamily: 0, familyIncompatible: 0, templateIncompatible: 0 },
}

export function MapInspectorContextReducer(state, action) {
  switch (action.type) {
    case MAP_INSPECTOR_ACTION_TYPES.SET_SELECTED_CROP:
      return {
        ...state,
        selectedCropId: action.cropId,
        selectedCropOrgId: action.orgId ?? null,
        hoveredCropId: null,
      }

    case MAP_INSPECTOR_ACTION_TYPES.SET_HOVERED_CROP:
      return {
        ...state,
        hoveredCropId: action.cropId,
      }

    case MAP_INSPECTOR_ACTION_TYPES.SET_PLOT_STATUS_MAP:
      return {
        ...state,
        plotStatusMap: action.plotStatusMap,
      }

    case MAP_INSPECTOR_ACTION_TYPES.SET_RELATIONSHIP_COUNTS:
      return {
        ...state,
        relationshipCounts: action.relationshipCounts,
      }

    default:
      throw new Error('Unknown action sent to MapInspectorContextReducer: ' + action.type)
  }
}
